import { mapToCompanyError } from '@/utils/companyUtils';

import B3Request from '../../request/b3Fetch';

import { storefrontGQLRequest } from './client';

interface LoginData {
  loginData: {
    storeHash: string;
    email: string;
    password: string;
    channelId: number;
  };
}

interface UserLoginResult {
  login: {
    result: {
      token: string;
      storefrontLoginToken: string;
      permissions: [
        {
          code: string;
          permissionLevel: number;
        },
      ];
    };
    errors?: { message: string }[];
  };
}

const getBcLogin = () => `mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    result,
    customer {
      entityId,
      phone,
      firstName,
      lastName,
      email,
      customerGroupId,
    }
  }
}`;

const logoutLogin = () => `mutation Logout {
  logout {
    result
  }
}`;

const getB2bLogin = `mutation Login($loginData: UserLoginType!) {
  login(loginData: $loginData) {
    result{
      storefrontLoginToken
      token
      permissions {
        code
        permissionLevel
      }
    }
  }
}`;

export const b2bLogin = (variables: LoginData): Promise<UserLoginResult> =>
  B3Request.graphqlB2B<UserLoginResult>(
    {
      query: getB2bLogin,
      variables,
    },
    true,
  ).catch(mapToCompanyError);

interface LoginVariables {
  email: string;
  password: string;
}

export const bcLogin = (variables: LoginVariables) =>
  storefrontGQLRequest({
    query: getBcLogin(),
    variables,
  });

export const bcLogoutLogin = () =>
  storefrontGQLRequest({
    query: logoutLogin(),
  });

interface BCPermission {
  code: string;
  permissionLevel: number;
}

interface BCAuthorizationInput {
  bcToken: string;
  channelId: number;
}

interface BCAuthorizationResponse {
  data?: {
    authorization?: {
      __typename: string;
      result?: {
        permissions: BCPermission[];
      };
    };
  };
  errors?: Array<{ message: string }>;
}

const GET_BC_AUTHORIZATION = `mutation BCAuthorization($authData: UserAuthType!) {
  authorization(authData: $authData) {
    __typename
    result {
      permissions {
        code
        permissionLevel
      }
    }
  }
}`;

/** @public Reserved for follow-up ticket; remove when wired into login flow. */
export async function bcAuthorization(
  authData: BCAuthorizationInput,
): Promise<BCAuthorizationResponse> {
  return storefrontGQLRequest<BCAuthorizationResponse>({
    query: GET_BC_AUTHORIZATION,
    variables: { authData },
  });
}
